import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Approve / reject correction request with optional comment (shared shell for attendance flows).
 * @param {{
 *   open: boolean,
 *   mode: 'approve' | 'reject' | null | undefined,
 *   comment: string,
 *   onCommentChange: (value: string) => void,
 *   onClose: () => void,
 *   onConfirm: () => void,
 *   confirmDisabled?: boolean,
 * }} props
 */
const AttendanceChangeRequestDecisionModal = ({
  open,
  mode,
  comment,
  onCommentChange,
  onClose,
  onConfirm,
  confirmDisabled = false,
}) => {
  const { t } = useTranslation();

  if (!open || !mode) return null;

  const isApprove = mode === "approve";

  return (
    <div
      className="att-modal-overlay"
      role="presentation"
      onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        className="att-modal att-modal--decision"
        role="dialog"
        aria-modal="true"
        aria-labelledby="att-cr-decision-title"
        style={{ maxWidth: 440 }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="att-modal-header">
          <h2 className="att-modal-title mb-0" id="att-cr-decision-title">
            {isApprove ? t("app.attendance.changeRequests.approve") : t("app.attendance.changeRequests.reject")}
          </h2>
          <button type="button" className="att-modal-close" onClick={onClose} aria-label={t("app.common.close")}>
            ×
          </button>
        </div>
        <div className="att-modal-body">
          <label className="att-modal-field-label" htmlFor="att-cr-decision-comment">
            {t("app.attendance.changeRequests.comment")}
          </label>
          <textarea
            id="att-cr-decision-comment"
            className="form-control att-modal--decision__textarea"
            rows={3}
            value={comment}
            onChange={(e) => onCommentChange(e.target.value)}
            placeholder={t("app.attendance.changeRequests.commentOptional")}
          />
        </div>
        <div className="att-modal-footer att-modal-footer--decision">
          <button type="button" className="att-btn att-btn--ghost att-modal-footer__cancel" onClick={onClose}>
            {t("app.common.cancel")}
          </button>
          {isApprove ? (
            <button
              type="button"
              className="att-modal-btn-confirm-approve"
              disabled={confirmDisabled}
              onClick={onConfirm}
            >
              {t("app.attendance.changeRequests.approve")}
            </button>
          ) : (
            <button
              type="button"
              className="att-modal-btn-confirm-reject"
              disabled={confirmDisabled}
              onClick={onConfirm}
            >
              {t("app.attendance.changeRequests.reject")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AttendanceChangeRequestDecisionModal;
